// Copyright 2026 Epic Digital Interactive Media LLC
// SPDX-License-Identifier: Apache-2.0

import { z } from 'zod'

export const sagaSystemRegistrySchema = z.object({
  id: z.string().max(200),
  orgId: z.string().max(100),
  workspaceId: z.string().max(100).optional(),

  systemUrl: z.string().max(500),
  systemId: z.string().max(100),
  walletAddress: z.string().max(200),
  chain: z.string().max(50),

  exportPolicy: z.object({
    defaultClassification: z.string(),
    agentPortableByDefault: z.array(z.string()),
    neverExport: z.array(z.string()),
    requiresApproval: z.array(z.string()),
  }).optional(),

  sharingPolicy: z.object({
    canShareTo: z.array(z.string()),
    cannotShareTo: z.array(z.string()),
    requireOriginConsent: z.boolean(),
  }).optional(),

  conformanceLevel: z.number().int().min(1).max(4).default(1),
  lastSyncAt: z.string().max(200).datetime().optional(),
  registeredAt: z.string().max(200).datetime(),
})

export type SagaSystemRegistryInput = z.infer<typeof sagaSystemRegistrySchema>
